/**
 * This file launches on start and does loging and check authentication
*/

import Vue from 'vue'
import App from './App.vue'
import { router } from "@/routes.js";
import vuetify from "./plugins/vuetify";
import Keycloak from "keycloak-js";
import '@mdi/font/css/materialdesignicons.css' 
import './assets/css/main.css';

Vue.config.productionTip = false
Vue.use(vuetify);
Vue.prototype.appConfig = config;

const KEYCLOAK_URL = config.VUE_APP_KEYCLOAK_URL || process.env.VUE_APP_KEYCLOAK_URL;
const KEYCLOAK_REALM = config.VUE_APP_KEYCLOAK_REALM || process.env.VUE_APP_KEYCLOAK_REALM;
const KEYCLOAK_CLIENT_ID = config.VUE_APP_KEYCLOAK_CLIENT_ID || process.env.VUE_APP_KEYCLOAK_CLIENT_ID;

let initOptions = {
    url: KEYCLOAK_URL, 
    realm: KEYCLOAK_REALM, 
    clientId: KEYCLOAK_CLIENT_ID, 
    onLoad: 'login-required',
}

let keycloak = new Keycloak(initOptions);

/**
 * Setting up keycloak connection if anything goes wrong log out by keycloak.
 * Using localstorage tokens on init so that on an active session there is no need to log in again.
 */
keycloak.init({ 
    checkLoginIframe: false, 
    onLoad: initOptions.onLoad, 
    promiseType: 'native',
    token: localStorage.getItem('token'),
    refreshToken: localStorage.getItem('refreshToken')
}).then((auth) => {
    if (!auth) {
        window.location.reload();
    } else {
        if(keycloak.tokenParsed && keycloak.tokenParsed.resource_access ){
                new Vue({
                    render: h => h(App),
                    vuetify,
                    router
                }).$mount('#app');
                //Saving tokens on localStorage after a succesfull login
                localStorage.setItem('token', keycloak.token);
                localStorage.setItem('refreshToken', keycloak.refreshToken);
            }
        else {
            localStorage.clear();
            keycloak.logout();
        }
    }
    //Token Refresh
    setInterval(() => {
        keycloak.updateToken(70).then((refreshed) =>{
            if(refreshed) {
                //Saving tokens on localStorage after a succesfull refresh
                localStorage.setItem('token', keycloak.token);
                localStorage.setItem('refreshToken', keycloak.refreshToken);
            }
        }
        ).catch(() => {
            localStorage.clear();
            keycloak.logout();
        });
    }, 6000)

}).catch(() => {
    localStorage.clear();
    keycloak.logout();
});

export {
    keycloak
}
